import {initialState} from '@ispm-client/modules/bpmn-modeler/store/state';
import {
  FloatedNodesAction,
  FloatingNodesActionTypes
} from '@ispm-client/modules/bpmn-modeler/store/actions/floating-nodes.actions';
import {uniq} from 'lodash';
import {MapUtils} from "@ispm/shared/utils/Map.utils";

export function floatingNodesInfo(state = initialState.floatedNodes, action: FloatedNodesAction) {
  switch (action.type) {
    case FloatingNodesActionTypes.FLOATED_NODES_INIT: {
      return MapUtils.convertFromObjectToMap(action.payload);
    }
    case FloatingNodesActionTypes.FLOATED_NODES_ADDED: {
      let newState;
      if(!(state instanceof Map)){
        newState = MapUtils.convertFromObjectToMap(state);
      } else {
        newState = new Map(state);
      }
      const floatedNodesToAdd = action.payload.nodes;
      if (newState.has(action.payload.layer)) {
          const  floatedNodes = newState.get(action.payload.layer);
          const newFloatedNodes = floatedNodes.concat(action.payload.nodes);
          // check if the floated node is already existed
          newState.set(action.payload.layer,uniq(newFloatedNodes));
      } else {
        newState.set(action.payload.layer,uniq(floatedNodesToAdd));
      }
      return newState;
    }
    case FloatingNodesActionTypes.FLOATED_NODES_REMOVED: {
      const floatedNodesResults = new Map(state);
      const layer = action.payload.layer;

      if (floatedNodesResults.has(layer)) {
        const floatedNodes = floatedNodesResults.get(layer);
        const floatedNodesToRemove = action.payload.nodes;
        floatedNodesToRemove.forEach((nodeId) => {
          let floatedNodeIndex = floatedNodes ? floatedNodes.findIndex(floatedNodeId => floatedNodeId === nodeId) : -1;
          if (floatedNodeIndex !== -1) {
            floatedNodes.splice(floatedNodeIndex, 1);
            if (floatedNodes.length === 0) {
              floatedNodesResults.delete(layer);
            }
          }
        });
      }
      return floatedNodesResults;
    }
    default: {
      return state;
    }
  }

}
